import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "../../components/molecures/Modals/AlertModal";
import ConfirmModal from "../../components/molecures/Modals/ConfirmModal";
import {
  AlertModalProps,
  ConfirmModalProps,
} from "../../components/molecures/Modals/_types";
import { RootState } from "../../redux/reducer";
import {
  addModal,
  removeModal,
  clearModal,
} from "../../redux/slices/ModalSlice";

export default function useModals() {
  const dispatch = useDispatch();
  const { modals, isLoading } = useSelector((state: RootState) => state.Modal);
  function openModal(modal: React.ReactNode) {
    dispatch(addModal(modal));
  }
  function resetModal() {
    dispatch(clearModal());
  }
  function closeModal() {
    dispatch(removeModal());
  }
  function getModals() {
    return modals;
  }
  function getLoading() {
    return isLoading;
  }
  function openAlertModal(props: AlertModalProps) {
    dispatch(addModal(<AlertModal {...props} />));
  }
  function openConfirmModal(props: ConfirmModalProps) {
    dispatch(addModal(<ConfirmModal {...props} />));
  }
  return {
    openModal,
    resetModal,
    closeModal,
    getLoading,
    getModals,
    openAlertModal,
    openConfirmModal,
  };
}
